// extracted by mini-css-extract-plugin
export default {"container":"CopyLink_container__Pff6g","icon":"CopyLink_icon__YExW5","iconLink":"CopyLink_iconLink__IEVOZ","iconChecked":"CopyLink_iconChecked__4LtXs"};